import React from 'react'
import { useTranslation } from 'react-i18next'
import { buildBreakdownLedgerRows } from '../../BreakdownLedger'
import getLocaleCurrencyForAmount from '../../../../../utils/getLocaleCurrencyForAmount'
import { LedgerRow } from '../../../../Table/LedgerTable'
import { Breakdown } from '../../Breakdown'
import { convertTwoDecimalStringToBig } from '../../../../../utils/bigJSHelper'

interface LicenseBalanceSectionProps {
  totalOwed: string
  totalPaid: string
  balance: string
  currencyCode: string
  licensingDue: string
}

const LicenseBalanceSection: React.FC<LicenseBalanceSectionProps> = ({
  totalOwed,
  totalPaid,
  balance,
  currencyCode,
  licensingDue,
}) => {
  const { t } = useTranslation()

  const totalOwedRow = buildBreakdownLedgerRows(
    { content: t('LicenseBalanceSection.Balance.Row.TotalOwed', 'Total Owed') },
    {
      content: `${getLocaleCurrencyForAmount(totalOwed, currencyCode)}`,
      colSpan: 3,
    }
  )

  const totalPaidRow = buildBreakdownLedgerRows(
    {
      content: t('LicenseBalanceSection.Balance.Row.TotalPaid', 'Total Paid'),
      color: 'main',
    },
    {
      content: `${
        convertTwoDecimalStringToBig(totalPaid).gt(0) ? '-' : ''
      }${getLocaleCurrencyForAmount(totalPaid, currencyCode)}`,
      color: 'main',
      colSpan: 3,
    }
  )

  const balanceRow = buildBreakdownLedgerRows(
    {
      content: t('LicenseBalanceSection.Balance.Row.Balance', 'Balance'),
      cellCssProps: {
        height: 60,
      },
    },
    {
      content: `${getLocaleCurrencyForAmount(balance, currencyCode)}`,
      color: 'medium',
      colSpan: 3,
      cssTextProps: {
        fontWeight: 'bold',
        fontSize: 16,
      },
      cellCssProps: {
        height: 60,
      },
    }
  )

  const licensingDueRow = buildBreakdownLedgerRows(
    {
      content: t('LicenseBalanceSection.Balance.Row.LicenseDue', 'License Due'),
    },
    {
      content: `${getLocaleCurrencyForAmount(licensingDue, currencyCode)}`,
      color: 'medium',
      colSpan: 3,
      cssTextProps: {
        fontWeight: 'bold',
        fontSize: 16,
      },
    }
  )

  const balanceRows: LedgerRow[] = [
    totalOwedRow,
    totalPaidRow,
    balanceRow,
    licensingDueRow,
  ]

  return (
    <Breakdown
      breakdownRows={balanceRows}
      variant="Balance"
      cellStyles={{
        padding: 0,
        height: 30,
      }}
    />
  )
}

export default LicenseBalanceSection
